import { render, staticRenderFns } from "./user-grade.vue?vue&type=template&id=221ac840&"
import script from "./user-grade.vue?vue&type=script&lang=js&"
export * from "./user-grade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports